<template>
    <div id="multiple-orders-quantity">
        <header class="header-operator">
            <span class="header__back" @click="handleBack">
                <BackIcon />
            </span>
            <div class="header__titles">
                <span class="header__title">{{ $t("Operator.CardMultipleOrdersTitle") }}</span>
                <span class="header__subtitle">{{ $t("Operator.CardMultipleOrdersSubTitle") }}</span>
            </div>
        </header>

        <div class="content">
            <div v-for="operation in operations" :key="operation.operation.id" class="operation-card">
                <div class="operation-card__top">
                    <span class="operation-card__order">
                        {{ `${operation.order.number}/${operation.operation.number}` }}
                    </span>
                    <span class="operation-card__status"
                        :style="getBackgroundColorLegend(operation.operation.statusColor)">
                        {{ operation.operation.statusName }}
                    </span>
                </div>

                <div class="operation-card__info">
                    <div class="info-container">
                        <span class="info-title">{{ $t("Operator.Barcode.Resource") }}</span>
                        <span class="info-content">{{ formatResources(operation.resource) }}</span>
                    </div>
                    <div class="info-container">
                        <span class="info-title">{{ $t("Operator.Barcode.Product") }}</span>
                        <span class="info-content">{{ operation.operation.productName || "—" }}</span>
                    </div>
                    <div class="info-container">
                        <span class="info-title">{{ $t("Operator.Barcode.Operation") }}</span>
                        <span class="info-content">{{ operation.operation.name || "—" }}</span>
                    </div>
                    <div class="info-container">
                        <span class="info-title">{{ $t("QTY") }}</span>
                        <span class="info-content">{{ operation.operation.totalQuantity }}</span>
                    </div>
                    <div class="info-container">
                        <span class="info-title">{{ $t("QTYPROD") }}</span>
                        <span class="info-content">{{ operation.operation.producedQuantity }}</span>
                    </div>
                    <div class="info-container">
                        <span class="info-title">Prod</span>
                        <span class="info-content">{{ operation.operation.prodPercent }}%</span>
                    </div>
                    <div class="info-container">
                        <span class="info-title">{{ $t("ordersList.SetupStart") }}</span>
                        <span class="info-content">{{ getFormatedDate(operation.operation.setupStart) }}</span>
                    </div>
                    <div class="info-container">
                        <span class="info-title">{{ $t("Operator.StartTime") }}</span>
                        <span class="info-content">{{ getFormatedDate(operation.operation.startTime) }}</span>
                    </div>
                    <div class="info-container">
                        <span class="info-title">{{ $t("Operator.EndTime") }}</span>
                        <span class="info-content">{{ getFormatedDate(operation.operation.endTime) }}</span>
                    </div>
                </div>

                <div class="operation-card__fields">
                    <div class="quantity-field-card">
                        <div class="quantity-field-card__icon">
                            <ProducedIcon />
                        </div>
                        <div class="quantity-field-card__content">
                            <span class="quantity-field-card__label">{{ $t("QTYPROD") }}</span>
                            <input :value="forms[operation.operation.id].producedQuantity" type="text"
                                inputmode="decimal" class="quantity-field-card__input"
                                @focus="handleQuantityFocus(operation.operation.id, 'producedQuantity', $event)"
                                @keydown="filterQuantityKeydown($event)"
                                @paste="handleQuantityPaste(operation.operation.id, 'producedQuantity', $event)"
                                @input="sanitizeQuantityField(operation.operation.id, 'producedQuantity', $event)" />
                        </div>
                        <div class="quantity-field-card__warn">
                            <WarnIcon />
                        </div>
                    </div>

                    <div class="quantity-field-card">
                        <div class="quantity-field-card__icon">
                            <ReworkIcon />
                        </div>
                        <div class="quantity-field-card__content">
                            <span class="quantity-field-card__label">{{ $t("REWORK") }}</span>
                            <input :value="forms[operation.operation.id].rework" type="text" inputmode="decimal"
                                class="quantity-field-card__input"
                                @focus="handleQuantityFocus(operation.operation.id, 'rework', $event)"
                                @keydown="filterQuantityKeydown($event)"
                                @paste="handleQuantityPaste(operation.operation.id, 'rework', $event)"
                                @input="sanitizeQuantityField(operation.operation.id, 'rework', $event)" />
                        </div>
                        <div class="quantity-field-card__warn">
                            <WarnIcon />
                        </div>
                    </div>

                    <div class="quantity-field-card">
                        <div class="quantity-field-card__icon">
                            <RejectionIcon />
                        </div>
                        <div class="quantity-field-card__content">
                            <span class="quantity-field-card__label">{{ $t("REFUSE") }}</span>
                            <input :value="forms[operation.operation.id].refuse" type="text" inputmode="decimal"
                                class="quantity-field-card__input"
                                @focus="handleQuantityFocus(operation.operation.id, 'refuse', $event)"
                                @keydown="filterQuantityKeydown($event)"
                                @paste="handleQuantityPaste(operation.operation.id, 'refuse', $event)"
                                @input="sanitizeQuantityField(operation.operation.id, 'refuse', $event)" />
                        </div>
                        <div class="quantity-field-card__warn">
                            <WarnIcon />
                        </div>
                    </div>

                    <div :class="[
                        'quantity-field-card',
                        {
                            'quantity-field-card--alert': isReasonAlert(operation.operation.id),
                            'quantity-field-card--disabled': isReasonDisabled(operation.operation.id),
                            'quantity-field-card--dropdown-open': openReasonId === operation.operation.id
                        }
                    ]">
                        <div class="quantity-field-card__icon">
                            <ReasonIcon />
                        </div>
                        <div class="quantity-field-card__content">
                            <span class="quantity-field-card__label">
                                {{ $t("MOTIVO DE REFUGO") }}
                            </span>
                            <div class="reason-select">
                                <button
                                    type="button"
                                    :class="[
                                        'quantity-field-card__input',
                                        'quantity-field-card__input--select',
                                        'reason-select__trigger',
                                        {
                                            'quantity-field-card__input--placeholder': !forms[operation.operation.id].refuseReasonId,
                                            'quantity-field-card__input--alert': isReasonAlert(operation.operation.id),
                                            'reason-select__trigger--open': openReasonId === operation.operation.id
                                        }
                                    ]"
                                    :disabled="isReasonDisabled(operation.operation.id)"
                                    @click.stop="toggleReasonDropdown(operation.operation.id)"
                                >
                                    <span class="reason-select__value">
                                        {{ getReasonName(forms[operation.operation.id].refuseReasonId) || $t("Select") }}
                                    </span>
                                </button>
                                <ul
                                    v-if="openReasonId === operation.operation.id"
                                    class="reason-select__dropdown"
                                >
                                    <li
                                        v-for="reason in getRefuseReasons(operation.operation.workcenterId)"
                                        :key="reason.id"
                                        :class="[
                                            'reason-select__option',
                                            {
                                                'reason-select__option--selected':
                                                    forms[operation.operation.id].refuseReasonId === reason.id
                                            }
                                        ]"
                                        @click.stop="selectReason(operation.operation.id, reason.id)"
                                    >
                                        {{ reason.name }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="quantity-field-card__warn">
                            <WarnIcon />
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="!loading && operations.length === 0" class="empty">
                {{ $t("MultipleOrders.NoOrdersFound") }}
            </div>
        </div>

        <div class="footer-bar">
            <button type="button" class="footer-bar__button"
                :disabled="sending || operations.length === 0 || !hasAnyQuantityToSubmit" @click="confirmAppointments">
                {{ $t("MakeAppointment") }}
            </button>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import { mapMutations } from "vuex";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ProducedIcon from "@/assets/images/icons/produced-icon-1.svg";
import ReworkIcon from "@/assets/images/icons/rework-icon-1.svg";
import RejectionIcon from "@/assets/images/icons/refuse-icon-1.svg";
import ReasonIcon from "@/assets/images/icons/reason-icon-1.svg";
import WarnIcon from "@/assets/images/icons/warn-icon-1.svg";
import { filterAppointmentableMultipleOrders } from "@/views/pages/operator/utils";

export default {
    components: {
        BackIcon: () => import("@/assets/images/icons/back.svg"),
        ProducedIcon,
        ReworkIcon,
        RejectionIcon,
        ReasonIcon,
        WarnIcon
    },
    data() {
        return {
            currentSite: this.$cookies.get("userInfo").currentSite,
            operations: [],
            refuseReasons: [],
            statusList: [],
            forms: {},
            loading: false,
            sending: false,
            openReasonId: null
        };
    },
    computed: {
        hasAnyQuantityToSubmit() {
            return this.operations.some((operation) =>
                this.hasQuantityToSubmit(this.forms[operation.operation.id])
            );
        }
    },
    created() {
        this.loadData();
    },
    mounted() {
        document.addEventListener("click", this.handleOutsideClick);
    },
    beforeDestroy() {
        document.removeEventListener("click", this.handleOutsideClick);
    },
    methods: {
        getRefuseReasons(workcenterId) {
            return this.refuseReasons.filter(r => !r.workcenterIds?.length || r.workcenterIds.includes(workcenterId));
        },
        ...mapMutations("app", ["UPDATE_FLAG_SHOW_OVERLAY"]),
        showToast(title, icon, text, variant) {
            this.$toast({
                component: ToastificationContent,
                props: {
                    title,
                    icon,
                    text,
                    variant
                }
            });
        },
        handleOutsideClick() {
            this.openReasonId = null;
        },
        toggleReasonDropdown(operationId) {
            if (this.isReasonDisabled(operationId)) return;
            this.openReasonId = this.openReasonId === operationId ? null : operationId;
        },
        selectReason(operationId, reasonId) {
            this.$set(this.forms[operationId], "refuseReasonId", reasonId);
            this.openReasonId = null;
        },
        getReasonName(reasonId) {
            if (!reasonId) return "";
            const reason = this.refuseReasons.find((item) => item.id === reasonId);
            return reason?.name || "";
        },
        async loadData() {
            this.loading = true;
            this.UPDATE_FLAG_SHOW_OVERLAY(true);
            try {
                await this.getContext();
                await this.getOperations();
            } finally {
                this.loading = false;
                this.UPDATE_FLAG_SHOW_OVERLAY(false);
            }
        },
        async getContext() {
            const response = await this.$http2.get(
                `/api/mysfc/operation-progress/context?siteId=${this.currentSite}&workcenterId=${this.$route.query.workcenterId || ""}&operationId=${this.$route.params.order_id || ""}&resourceId=${this.$route.params.resource_id || ""}`
            );
            const data = response.data.data;
            this.statusList = data.status ?? [];
            this.refuseReasons = data.refuseReasons ?? [];
        },
        async getOperations() {
            const ids = (this.$route.params.preactor_orders || "")
                .split(",")
                .filter((id) => id !== "");

            if (ids.length === 0) {
                this.operations = [];
                return;
            }

            const response = await this.$http2.get(
                `/api/mysfc/operator/multiple/operations?Ids=${ids}&SiteId=${this.currentSite}&isRework=false`
            );

            const data = response.data?.data || {};
            const statusName = data.lastInfo?.lastStatus || "";
            const statusColor = data.statusColor || data.lastInfo?.lastColorStatus || "";

            const list = (data.operations || []).map((op) => ({
                operation: {
                    id: op.operationId,
                    workcenterId: op.workcenterId,
                    number: op.operationNumber,
                    name: op.operationName,
                    productName: op.product,
                    totalQuantity: op.plannedQuantity || 0,
                    producedQuantity: op.producedQuantity || 0,
                    prodPercent: ((op.realProgress || 0) * 100).toFixed(0),
                    statusName,
                    statusColor,
                    setupStart: data.setupStart,
                    startTime: data.startTime,
                    endTime: data.endTime
                },
                order: {
                    number: op.orderNumber
                },
                resource: op.resource || data.resource || []
            }));

            this.operations = filterAppointmentableMultipleOrders(list);

            this.operations.forEach((item) => {
                this.$set(this.forms, item.operation.id, {
                    producedQuantity: "0",
                    rework: "0",
                    refuse: "0",
                    refuseReasonId: null
                });
            });
        },
        filterQuantityKeydown(event) {
            const allowedKeys = [
                "Backspace",
                "Delete",
                "ArrowLeft",
                "ArrowRight",
                "ArrowUp",
                "ArrowDown",
                "Tab",
                "Home",
                "End",
                "Enter"
            ];

            if (allowedKeys.includes(event.key) || event.ctrlKey || event.metaKey) return;

            if (event.key === "," || event.key === ".") {
                const value = String(event.target.value).replace(/\./g, ",");

                if (value.includes(",")) {
                    event.preventDefault();
                }

                return;
            }

            if (!/^\d$/.test(event.key)) {
                event.preventDefault();
                return;
            }

            const input = event.target;
            const value = String(input.value).replace(/\./g, ",");
            const start = input.selectionStart ?? value.length;
            const end = input.selectionEnd ?? value.length;
            const newValue = `${value.slice(0, start)}${event.key}${value.slice(end)}`;

            if (this.wouldExceedQuantityLimit(newValue)) {
                event.preventDefault();
            }
        },
        handleQuantityPaste(operationId, field, event) {
            event.preventDefault();

            const pasted = (event.clipboardData || window.clipboardData).getData("text");
            const input = event.target;
            const value = String(input.value).replace(/\./g, ",");
            const start = input.selectionStart ?? value.length;
            const end = input.selectionEnd ?? value.length;
            const newValue = `${value.slice(0, start)}${pasted}${value.slice(end)}`;
            const normalized = this.normalizeQuantityInput(newValue);

            this.$set(this.forms[operationId], field, normalized);
            input.value = normalized;

            if (field === "refuse" && this.formatedNumber(normalized) === 0) {
                this.$set(this.forms[operationId], "refuseReasonId", null);
                if (this.openReasonId === operationId) {
                    this.openReasonId = null;
                }
            }
        },
        wouldExceedQuantityLimit(value) {
            const raw = String(value ?? "").replace(/\./g, ",").replace(/[^\d,]/g, "");
            const commaIndex = raw.indexOf(",");
            const integerDigits = (commaIndex === -1 ? raw : raw.slice(0, commaIndex)).replace(/\D/g, "");
            const decimalDigits = (commaIndex === -1 ? "" : raw.slice(commaIndex + 1).replace(/,/g, ""))
                .replace(/\D/g, "");

            return integerDigits.length > 9 || decimalDigits.length > 9;
        },
        normalizeQuantityInput(value) {
            let raw = String(value ?? "").trim().replace(/\./g, ",");

            if (raw === "") return "0";

            raw = raw.replace(/[^\d,]/g, "");

            const commaIndex = raw.indexOf(",");
            let integerPart = "";
            let decimalPart = "";

            if (commaIndex === -1) {
                integerPart = raw;
            } else {
                integerPart = raw.slice(0, commaIndex);
                decimalPart = raw.slice(commaIndex + 1).replace(/,/g, "");
            }

            integerPart = integerPart.replace(/\D/g, "").slice(0, 9);
            decimalPart = decimalPart.replace(/\D/g, "").slice(0, 9);

            if (integerPart === "") {
                integerPart = "0";
            } else if (integerPart.length > 1) {
                integerPart = integerPart.replace(/^0+/, "") || "0";
            }

            if (commaIndex === -1) {
                return integerPart;
            }

            return `${integerPart},${decimalPart}`;
        },
        handleQuantityFocus(operationId, field, event) {
            const form = this.forms[operationId];
            const currentValue = String(form?.[field] ?? "");

            if (!form || (currentValue !== "0" && form[field] !== 0)) return;

            this.$nextTick(() => {
                event.target.select();
            });
        },
        sanitizeQuantityField(operationId, field, event) {
            const form = this.forms[operationId];
            if (!form || !event?.target) return;

            const normalized = this.normalizeQuantityInput(event.target.value);

            event.target.value = normalized;
            this.$set(form, field, normalized);

            if (field === "refuse" && this.formatedNumber(normalized) === 0) {
                this.$set(form, "refuseReasonId", null);
                if (this.openReasonId === operationId) {
                    this.openReasonId = null;
                }
            }
        },
        isReasonDisabled(operationId) {
            const refuse = this.formatedNumber(this.forms[operationId]?.refuse);

            return refuse <= 0;
        },
        isReasonAlert(operationId) {
            const form = this.forms[operationId];
            if (!form) return false;

            const refuse = this.formatedNumber(form.refuse);

            return refuse > 0 && !form.refuseReasonId;
        },
        hasQuantityToSubmit(form) {
            const produced = this.formatedNumber(form.producedQuantity);
            const rework = this.formatedNumber(form.rework);
            const refuse = this.formatedNumber(form.refuse);

            return produced > 0 || rework > 0 || refuse > 0;
        },
        validateForms() {
            for (const operation of this.operations) {
                const form = this.forms[operation.operation.id];

                if (!this.hasQuantityToSubmit(form)) continue;

                const refuse = this.formatedNumber(form.refuse);

                if (refuse > 0 && !form.refuseReasonId) {
                    this.showToast(
                        this.$t("ProductionProgress.Toasts.RequiredFields.Title"),
                        "FrownIcon",
                        `${this.$t("MultipleOrders.ReasonRequired")} (${operation.order.number}/${operation.operation.number})`,
                        "danger"
                    );
                    return false;
                }
            }

            return true;
        },
        formatResources(resources) {
            return (resources || []).map((resource) => resource.name).join(", ");
        },
        getFormatedDate(date) {
            if (!date) return "—";

            const language = this.$cookies.get("userInfo").language;
            if (language == "pt-BR") return moment(date).format("DD-MM-YYYY HH:mm");

            return moment(date).format("MM-DD-YYYY HH:mm");
        },
        getBackgroundColorLegend(color) {
            if (color) return `color:${color}; background-color:${color}20`;

            return "";
        },
        adjustTimeZone3(inputDate) {
            let date = inputDate;

            if (!(inputDate instanceof Date)) {
                date = new Date(inputDate);
            }

            const offset = date.getTimezoneOffset() * 60000;
            return new Date(date.getTime() - offset).toISOString().slice(0, -1);
        },
        formatedNumber(value) {
            if (value === null || value === undefined || value === "") return 0;
            if (typeof value === "number") return value < 0 ? 0 : value;
            if (typeof value !== "string") return value;
            const cleaned = value.replace(/\./g, "").replace(",", ".");
            const parsed = parseFloat(cleaned);
            if (Number.isNaN(parsed) || parsed < 0) return 0;

            return parsed;
        },
        async confirmAppointments() {
            if (!this.validateForms()) return;

            const executingStatus = this.statusList.find((s) => s.name === "Executando");

            if (!executingStatus) {
                this.showToast(
                    this.$t("Error"),
                    "FrownIcon",
                    this.$t("MultipleOrders.StatusNotFound"),
                    "danger"
                );
                return;
            }

            const resourceId = this.$route.params.resource_id;
            const userGuid = this.$cookies.get("userInfo").userData.guid;
            const eventTime = this.adjustTimeZone3(new Date());

            this.sending = true;
            this.UPDATE_FLAG_SHOW_OVERLAY(true);

            const operationsToSubmit = this.operations.filter((operation) =>
                this.hasQuantityToSubmit(this.forms[operation.operation.id])
            );

            if (operationsToSubmit.length === 0) {
                this.sending = false;
                this.UPDATE_FLAG_SHOW_OVERLAY(false);
                return;
            }

            try {
                for (const operation of operationsToSubmit) {
                    const form = this.forms[operation.operation.id];
                    const body = {
                        operationId: operation.operation.id,
                        userGuid,
                        statusId: executingStatus.id,
                        producedQuantity: this.formatedNumber(form.producedQuantity),
                        refuse: this.formatedNumber(form.refuse),
                        rework: this.formatedNumber(form.rework),
                        resourceId,
                        eventTime,
                        refuseReasonId: form.refuseReasonId || null,
                        isRework: false,
                        industrialParameter: []
                    };

                    await this.$http2.post(
                        `/api/mysfc/operator/operation-progress?siteId=${this.currentSite}`,
                        body
                    );
                }

                this.showToast(
                    this.$t("ProductionProgress.Success"),
                    "FrownIcon",
                    this.$t("ProductionProgress.OperationProgressRegistred"),
                    "success"
                );

                this.handleBack();
            } catch (error) {
                if (error?.response?.data?.errors) {
                    error.response.data.errors.map((e) => {
                        let message =
                            e.id == 196
                                ? this.$t("MandatoryMaterialsError")
                                : this.$t(e.message ?? "");
                        this.showToast(this.$t("Error"), "FrownIcon", message, "danger");
                    });
                } else {
                    this.showToast(
                        this.$t("Error"),
                        "FrownIcon",
                        this.$t("Error"),
                        "danger"
                    );
                }
            } finally {
                this.sending = false;
                this.UPDATE_FLAG_SHOW_OVERLAY(false);
            }
        },
        handleBack() {
            const prefix = localStorage.getItem("prefix") || this.$route.params.prefix;
            const query = {
                perOrderQuantity: "true",
                fromMultipleOrdersByResource: "true"
            };

            if (this.$route.query.groupId) {
                query.groupId = this.$route.query.groupId;
            }

            if (this.$route.query.workcenterId) {
                query.workcenterId = this.$route.query.workcenterId;
            }

            this.$router.push({
                name: "operator-production-progress-multiple",
                params: {
                    prefix,
                    resource_id: this.$route.params.resource_id,
                    multiple: "true",
                    preactor_orders: this.$route.params.preactor_orders,
                    appointment_type: 0
                },
                query
            });
        }
    }
};
</script>

<style lang="scss">
.app-content-operator:has(#multiple-orders-quantity) {
    padding: 0 !important;
}

#multiple-orders-quantity {
    width: 100%;

    .header-operator {
        display: flex;
        align-items: center;
        gap: 16px;
        width: 100%;
        padding: 16px 29px;
        background: #ffffff;
        color: #4c4541;
        border-top: 1px solid #cfc4be;
        box-shadow: 0px 8px 30px rgba(58, 46, 38, 0.1);

        .header__back {
            display: flex;
            cursor: pointer;
        }

        .header__titles {
            display: flex;
            flex-direction: column;

            .header__title {
                font-family: "Raleway", sans-serif;
                font-weight: 600;
                font-size: 22px;
                line-height: 30px;
            }

            .header__subtitle {
                color: #998f8a;
                font-size: 14px;
                font-weight: 400;
                line-height: 20px;
            }
        }
    }

    .content {
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding: 24px 29px 109px;
    }

        .operation-card {
        background: #ffffff;
        border: 1px solid #cfc4be;
        border-radius: 6px;
        padding: 24px 16px;
        overflow: visible;
        position: relative;

        .operation-card__top {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 16px;

            .operation-card__order {
                font-family: "Raleway", sans-serif;
                font-weight: 600;
                font-size: 16px;
                line-height: 26px;
                color: #4c4541;
            }

            .operation-card__status {
                border-radius: 4px;
                padding: 1px 6px;
                font-weight: 600;
                font-size: 12px;
                line-height: 16px;
            }
        }

        .operation-card__info {
            display: flex;
            flex-wrap: wrap;
            gap: 16px;
            padding-top: 24px;

            .info-container {
                width: calc((100% / 3) - (32px / 3));
                display: flex;
                flex-direction: column;

                .info-title {
                    font-size: 12px;
                    line-height: 16px;
                    color: #998f8a;
                }

                .info-content {
                    font-weight: 600;
                    font-size: 14px;
                    line-height: 20px;
                    color: #4c4541;
                    word-break: break-word;
                }
            }
        }

        .operation-card__fields {
            display: flex;
            flex-wrap: wrap;
            gap: 16px;
            padding-top: 24px;
            overflow: visible;

            .quantity-field-card {
                display: flex;
                align-items: stretch;
                flex: 1 1 calc(50% - 8px);
                min-width: 220px;
                border: 1px solid #ffa726;
                border-radius: 16px;
                background: #fafafa;
                overflow: hidden;
                transition: background-color 0.2s ease, border-color 0.2s ease;

                &--dropdown-open {
                    overflow: visible;
                    z-index: 5;
                }

                &:hover:not(.quantity-field-card--disabled) {
                    background: #ffede2;
                    border-color: #974900;

                    .quantity-field-card__icon {
                        border-color: #974900;

                        svg {
                            fill: #974900;
                        }
                    }

                    .quantity-field-card__label {
                        color: #974900;
                    }

                    .quantity-field-card__input:not(:disabled) {
                        color: #974900;
                        border-color: #974900;
                    }

                    .quantity-field-card__input--select:not(:disabled):not(.quantity-field-card__input--placeholder):not(.quantity-field-card__input--alert) {
                        background-image: url("data:image/svg+xml;charset=utf8,%3Csvg width='8' height='6' viewBox='0 0 8 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 1.44333L0.943 0.5L4.00133 3.613L7.057 0.5L8 1.44333L4.00133 5.5L0 1.44333Z' fill='%23974900'/%3E%3C/svg%3E");
                    }

                    .quantity-field-card__warn svg {
                        fill: #974900;
                    }
                }

                &:active:not(.quantity-field-card--disabled) {
                    background: #ffdbc4;
                }

                &__icon {
                    min-width: 68px;
                    max-width: 68px;
                    border-right: 1px solid #ffa726;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    svg {
                        width: 20px;
                        height: 20px;
                        fill: #ffa726;
                    }
                }

                &__content {
                    flex: 1;
                    padding: 16px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    min-width: 0;
                }

                &__label {
                    font-size: 14px;
                    line-height: 20px;
                    color: #998f8a;
                    margin-bottom: 4px;
                }

                &__input {
                    width: 100%;
                    height: 40px;
                    border: 1px solid #cfc4be;
                    border-radius: 6px;
                    background: #ffffff;
                    font-weight: 600;
                    font-size: 16px;
                    line-height: 26px;
                    color: #4c4541;
                    padding: 8px 12px;
                    transition: border-color 0.2s ease, background-color 0.2s ease;

                    &:focus {
                        outline: none;
                        border-color: #974900;
                    }

                    &--select {
                        appearance: none;
                        -webkit-appearance: none;
                        -moz-appearance: none;
                        cursor: pointer;
                        padding-right: 32px;
                        background-image: url("data:image/svg+xml;charset=utf8,%3Csvg width='8' height='6' viewBox='0 0 8 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 1.44333L0.943 0.5L4.00133 3.613L7.057 0.5L8 1.44333L4.00133 5.5L0 1.44333Z' fill='%23974900'/%3E%3C/svg%3E");
                        background-repeat: no-repeat;
                        background-position: calc(100% - 12px) center;
                        background-size: 8px 6px;
                        text-align: left;

                        &--placeholder {
                            color: #ffa726;
                            background-image: url("data:image/svg+xml;charset=utf8,%3Csvg width='8' height='6' viewBox='0 0 8 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 1.44333L0.943 0.5L4.00133 3.613L7.057 0.5L8 1.44333L4.00133 5.5L0 1.44333Z' fill='%23ffa726'/%3E%3C/svg%3E");
                        }

                        &--alert:not(:disabled) {
                            border-color: #ffa726;
                            color: #ffa726;
                            background-image: url("data:image/svg+xml;charset=utf8,%3Csvg width='8' height='6' viewBox='0 0 8 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 1.44333L0.943 0.5L4.00133 3.613L7.057 0.5L8 1.44333L4.00133 5.5L0 1.44333Z' fill='%23ffa726'/%3E%3C/svg%3E");
                        }
                    }

                    &:disabled {
                        color: #998f8a;
                        background-color: #f3efec;
                        border-color: #cfc4be;
                        cursor: not-allowed;
                    }
                }

                .reason-select {
                    position: relative;
                    width: 100%;

                    &__trigger {
                        width: 100%;
                        display: flex;
                        align-items: center;

                        &--open {
                            border-color: #974900;
                            color: #974900;
                        }
                    }

                    &__value {
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }

                    &__dropdown {
                        position: absolute;
                        top: calc(100% + 4px);
                        left: 0;
                        right: 0;
                        z-index: 20;
                        margin: 0;
                        padding: 4px 0;
                        list-style: none;
                        background: #ffffff;
                        border: 1px solid #974900;
                        border-radius: 6px;
                        box-shadow: 0px 4px 16px rgba(58, 46, 38, 0.12);
                        max-height: 200px;
                        overflow-y: auto;
                    }

                    &__option {
                        padding: 10px 12px;
                        font-weight: 600;
                        font-size: 16px;
                        line-height: 26px;
                        color: #4c4541;
                        cursor: pointer;

                        &:hover {
                            background: #ffede2;
                            color: #974900;
                        }

                        &--selected {
                            background: #ffdbc4;
                            color: #974900;
                        }
                    }
                }

                &__warn {
                    display: flex;
                    align-items: center;
                    padding: 0 16px;

                    svg {
                        width: 20px;
                        height: 20px;
                        fill: #ffa726;
                    }
                }

                &--alert {
                    border-color: #ffa726;
                }

                &--disabled {
                    background: #e0e0e0;
                    border-color: #7e7570;
                    cursor: not-allowed;

                    .quantity-field-card__icon {
                        border-color: #7e7570;

                        svg {
                            fill: #998f8a;
                        }
                    }

                    .quantity-field-card__label {
                        color: #7e7570;
                    }

                    .quantity-field-card__warn svg {
                        fill: #998f8a;
                    }

                    .quantity-field-card__input--select {
                        color: #998f8a;
                        background-color: #f3efec;
                        border-color: #cfc4be;
                        background-image: url("data:image/svg+xml;charset=utf8,%3Csvg width='8' height='6' viewBox='0 0 8 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 1.44333L0.943 0.5L4.00133 3.613L7.057 0.5L8 1.44333L4.00133 5.5L0 1.44333Z' fill='%23998f8a'/%3E%3C/svg%3E");
                    }
                }
            }
        }
    }

    .empty {
        text-align: center;
        color: #998f8a;
        padding: 32px 12px;
    }

    .footer-bar {
        display: flex;
        justify-content: flex-end;
        position: fixed;
        bottom: 20px;
        right: 29px;
        z-index: 10;

        .footer-bar__button {
            border: none;
            border-radius: 5px;
            background: #974900;
            color: #ffffff;
            font-weight: 600;
            font-size: 17px;
            line-height: 20px;
            padding: 13px 28px;
            cursor: pointer;
            box-shadow: 0px 4px 24px 0px rgba(58, 46, 38, 0.1);

            &:hover {
                background: #7a3a00;
            }

            &:disabled {
                opacity: 0.5;
                cursor: not-allowed;
            }
        }
    }
}

@media (max-width: 767px) {
    #multiple-orders-quantity {
        padding-top: 49px;

        .operation-card {
            .operation-card__info {
                .info-container {
                    width: 100%;
                    flex-direction: row;
                    justify-content: space-between;

                    .info-content {
                        text-align: right;
                    }
                }
            }

            .operation-card__fields {
                .quantity-field-card {
                    flex: 1 1 100%;

                    &__icon {
                        min-width: 48px;
                        max-width: 48px;
                    }

                    &__content {
                        padding: 12px 16px;
                    }

                    &__label {
                        font-size: 12px;
                        line-height: 16px;
                    }

                    &__input {
                        font-size: 14px;
                        line-height: 20px;
                    }

                    .reason-select__option {
                        font-size: 14px;
                        line-height: 20px;
                    }
                }
            }
        }
    }
}

@media (max-width: 575px) {
    #multiple-orders-quantity {
        .header-operator {
            padding: 16px;
        }

        .content {
            padding: 24px 16px 109px;
        }

        .footer-bar {
            right: 16px;
            left: 16px;

            .footer-bar__button {
                width: 100%;
            }
        }
    }
}
</style>
